export default "__VITE_ASSET__CUfM5SS1__"